"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sidebarToggle = _interopRequireDefault(require("./sidebarToggle.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SidebarToggle = function SidebarToggle(_ref) {
  var onClick = _ref.onClick;
  return _react["default"].createElement("div", {
    onClick: onClick,
    className: _sidebarToggle["default"]['toggle']
  }, _react["default"].createElement("div", {
    className: "".concat(_sidebarToggle["default"]['bar'], " ").concat(_sidebarToggle["default"]['top'])
  }), _react["default"].createElement("div", {
    className: "".concat(_sidebarToggle["default"]['bar'], " ").concat(_sidebarToggle["default"]['middle'])
  }), _react["default"].createElement("div", {
    className: "".concat(_sidebarToggle["default"]['bar'], " ").concat(_sidebarToggle["default"]['bottom'])
  }));
};

SidebarToggle.propTypes = {};
SidebarToggle.defaultProps = {};
var _default = SidebarToggle;
exports["default"] = _default;